import React from 'react';
import { motion } from 'framer-motion';

export const StarBorder = ({ children, className = '', ...props }) => {
  return (
    <motion.button
      className={`relative inline-flex overflow-hidden rounded-none p-[1px] focus:outline-none ${className}`}
      whileHover="hover"
      {...props}
    >
      <span className="absolute inset-[-1000%] animate-[spin_2s_linear_infinite] bg-[conic-gradient(from_90deg_at_50%_50%,#ffffff_0%,#000000_50%,#ffffff_100%)]" />
      <span className="inline-flex h-full w-full items-center justify-center bg-black px-8 py-6 text-lg font-medium text-white backdrop-blur-3xl">
        {children}
      </span>
    </motion.button>
  );
};